import {doGet, doDownload, doPost, doDownloadNew} from "../base";
import _ from 'lodash'

const DEVICES_URL = (deviceId = "", retrieveAll=false) => `/user_auth/devices${deviceId !== "" ? `/${deviceId}` : ""}${retrieveAll ? '/assignment': ""}`;

const SET_DAFAULTS = ({ page, limit, offset, sort }) => {
    let params = [];
    if (page && page !== null) {
        params.push("page=" + page);
    }
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }

    return params;
}

export const updateLocation = async ({deviceIds, clientIds, unAssign}) => {
    var url = DEVICES_URL("")+"/location";
    const body = {
        deviceIds: _.compact(deviceIds),
        clientIds: _.compact(clientIds),
        unAssign
    }
    return await doPost(body, url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
}

export const getDevices = async ({ clientId, page, limit, offset, sort, deviceIdentifier, unassigned, sortField, sortOrder, customers, serialNumbers, simNumbers, retrieveAll, isKarieDUO, fetchDevicePageIndicator }) => {
    var url = DEVICES_URL("", retrieveAll);
    let params = SET_DAFAULTS({ page, limit, offset, sort });

    if (clientId) params.push("clientId=" + clientId);
    if (deviceIdentifier) params.push("deviceIdentifier=" + deviceIdentifier);
    if (unassigned) params.push("unassigned=" + unassigned);
    if (sortField) params.push("sortField=" + sortField);
    if (sortOrder) params.push("sortOrder=" + sortOrder);
    if (customers) params.push("customers=" + customers);
    if (serialNumbers) params.push("serialNumbers=" + serialNumbers);
    if (simNumbers) params.push("simNumbers=" + simNumbers);
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    fetchDevicePageIndicator ? params.push("isFetchDevicePage=1") : params.push("isFetchDevicePage=0");

    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const getDevice = async (deviceId, { limit, offset, sort }) => {

    if (!deviceId || deviceId === null) {
        throw new Error("Device Id cannot be null.");
    }

    return {}
};

export const findSupportDevices = async ({ page, limit, serialNumber, versionStatusSelection: versionStatus, appVersionSelection: appVersion, pharmacySelect, facilitySelect, firmwareVersionSelection: firmwareVersion, installerVersionSelection: installerVersion, launcherVersionSelection: launcherVersion, assignedVersion, isKarieDUO, isFetchAllIds }) => {
    var url = DEVICES_URL("");
    url += "/support";
    let params = SET_DAFAULTS({ page, limit });
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    if (serialNumber && serialNumber !== "") params.push("serialNumber=" + serialNumber);
    if (appVersion && appVersion !== "") params.push("appVersion=" + encodeURIComponent(appVersion));
    if (assignedVersion && assignedVersion !== "") params.push("assignedVersion=" + assignedVersion);

    if (versionStatus) params.push("versionStatus=" + versionStatus)
    if (facilitySelect) params.push("facility=" + facilitySelect)
    if (firmwareVersion) params.push("firmwareVersion=" + firmwareVersion)
    if (installerVersion) params.push("installerVersion=" + installerVersion)
    if (pharmacySelect) params.push("pharmacy=" + pharmacySelect)
    if (launcherVersion) params.push("launcherVersion=" + launcherVersion)
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const findUpdatePackages = async ({ page, limit, isKarieDUO }) => {
    let url = DEVICES_URL("");
    url += "/apps/packages";

    let params = SET_DAFAULTS({ page, limit });
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
}

export const fetchLog = async (id) => {
    var url = DEVICES_URL("") + "/logs/download?id=" + id;

    return await doDownload(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const requestDeviceLogs = async (deviceId, startDate, endDate, logFile, dispenseImage) => {
    var url = DEVICES_URL("") + "/send_logs";

    return await doPost({ deviceId, startDate, endDate, logFile, dispenseImage }, url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
}

export const updateDevice = async ({ deviceIds, versionId, type, updatePackageId }) => {
    var url = DEVICES_URL("") + "/update";

    return await doPost({ deviceIds, versionId, type, updatePackageId }, url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const updateDeviceNew = async ({ deviceIds, versionId, type, updatePackageId, search, totalItems, isKarieDUO }) => {
    let url = DEVICES_URL("") + "/update_new";
    let deviceType
    isKarieDUO ? deviceType = "karieDUO" : deviceType = "Karie"
    return await doPost({ deviceIds, versionId, type, updatePackageId, search, totalItems, deviceType }, url).catch((error) => {
        throw error;
    });
};

export const deleteDevicePackages = async ({ packageId }) => {
    const url = DEVICES_URL("") + "/delete/packages";
    return await doPost({packageId}, url).catch((error) => {
        throw error
    })
}

export const updateDevicePhoneInformation = async ({ deviceId, SIMNumber, IMEI, clearToken }) => {
    const url = DEVICES_URL("") + "/updatePhoneInfo";

    return await doPost({ deviceId, SIMNumber, IMEI, clearToken }, url).catch((error) => {
        throw error;
    })
};

export const cancelUpdates = async ({ deviceIds }) => {
    var url = DEVICES_URL("") + "/update/cancel";

    return await doPost({ deviceIds }, url).catch((error) => {
        throw error;
    })
};

export const fetchVersions = async ({ type, limit, offset, sort, currentVersion, isDeviceTypeKarieDUO}) => {
    var url = DEVICES_URL("") + "/apps";
    let params = SET_DAFAULTS({ limit, offset, sort });
    isDeviceTypeKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    url += "&type=" + type;
    if (currentVersion) {
        url += "&currentVersion=" + currentVersion
    }
    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const requestDeviceCsv = async ({page, limit, serialNumber, versionStatusSelection: versionStatus, appVersionSelection: appVersion, pharmacySelect, facilitySelect, firmwareVersionSelection: firmwareVersion, installerVersionSelection: installerVersion, launcherVersionSelection: launcherVersion, assignedVersion, isKarieDUO, isFetchAllIds}) => {
    var url = DEVICES_URL("") + "/download_all";
    let params = SET_DAFAULTS({ page, limit });
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    if (serialNumber && serialNumber !== "") params.push("serialNumber=" + serialNumber);
    if (appVersion && appVersion !== "") params.push("appVersion=" + encodeURIComponent(appVersion));
    if (assignedVersion && assignedVersion !== "") params.push("assignedVersion=" + assignedVersion);

    if (versionStatus) params.push("versionStatus=" + versionStatus)
    if (facilitySelect) params.push("facility=" + facilitySelect)
    if (firmwareVersion) params.push("firmwareVersion=" + firmwareVersion)
    if (installerVersion) params.push("installerVersion=" + installerVersion)
    if (pharmacySelect) params.push("pharmacy=" + pharmacySelect)
    if (launcherVersion) params.push("launcherVersion=" + launcherVersion)
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    return await doDownloadNew(url).catch((error) => {
        throw error;
    });
}

export const findSupportDevicesUpdated = async ({ page, limit, serialNumber, versionStatusSelection: versionStatus, appVersionSelection: appVersion, pharmacySelect, facilitySelect, firmwareVersionSelection: firmwareVersion, installerVersionSelection: installerVersion, launcherVersionSelection: launcherVersion, assignedVersion, isKarieDUO, isFetchAllIds, activeUser }) => {
    var url = DEVICES_URL("");
    url += "/supportNew";
    let params = SET_DAFAULTS({ page, limit });
    isKarieDUO ? params.push("deviceType=karieDUO") : params.push("deviceType=karie")
    if (serialNumber && serialNumber !== "") params.push("serialNumber=" + serialNumber);
    if (appVersion && appVersion !== "") params.push("appVersion=" + encodeURIComponent(appVersion));
    if (assignedVersion && assignedVersion !== "") params.push("assignedVersion=" + assignedVersion);

    if (versionStatus) params.push("versionStatus=" + versionStatus)
    if (facilitySelect) params.push("facility=" + facilitySelect)
    if (firmwareVersion) params.push("firmwareVersion=" + firmwareVersion)
    if (installerVersion) params.push("installerVersion=" + installerVersion)
    if (pharmacySelect) params.push("pharmacy=" + pharmacySelect)
    if (launcherVersion) params.push("launcherVersion=" + launcherVersion)
    if (activeUser) params.push("activeUser=" + activeUser)
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    return await doGet(url).catch((error) => {
        // TODO CHECK STATUS AND ERROR CODE.
        throw error;
    });
};

export const findPin = async ({ deviceId, deviceVersion, deviceTimeZone, imei, simNumber, androidId, deviceSerialNumber, timeZoneOffset, regionId, isKarieDUO}) => {
    let url = DEVICES_URL("");
    url += "/admin/authorize_pin";
    let params = SET_DAFAULTS({});
    if (simNumber && simNumber !== "") params.push("simNumber=" + simNumber);
    if (deviceId && deviceId !== "") params.push("deviceId=" + deviceId);
    if (deviceVersion && deviceVersion !== "") params.push("deviceVersion=" + deviceVersion);
    if (imei && imei !== "") params.push("imei=" + imei);
    if (deviceTimeZone && deviceTimeZone !== "") params.push("deviceTimeZone=" + deviceTimeZone);
    if (androidId && androidId !== "") params.push("androidId=" + androidId);
    if (deviceSerialNumber && deviceSerialNumber) params.push("deviceSerialNumber=" + deviceSerialNumber);
    if (timeZoneOffset && timeZoneOffset !== "") params.push("timeZoneOffset=" + timeZoneOffset);
    if (regionId && regionId !== "") params.push("regionId=" + regionId);
    if (typeof isKarieDUO === 'boolean') params.push("isKarieDUO=" + isKarieDUO);
    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }
    return await doGet(url).catch((error) => {
        throw error;
    });
};

